import { useLocation } from "react-router-dom";
import en from "./en.json";
import es from "./es.json";

const DICTS = { en, es };

export function detectLang(pathname) {
  return (pathname === "/es" || pathname.startsWith("/es/")) ? "es" : "en";
}

function lookup(dict, key) {
  return key.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), dict);
}

export function useI18n() {
  const { pathname, search } = useLocation();
  const lang = detectLang(pathname);

  // t(key, englishFallback) — Spanish from es.json, English pages use the inline fallback.
  const t = (key, fallback = "") => {
    const val = lookup(DICTS[lang], key);
    if (val != null) return val;
    const enVal = lookup(en, key);
    return enVal != null ? enVal : fallback;
  };

  const stripped = lang === "es" ? (pathname.replace(/^\/es/, "") || "/") : pathname;
  const esPath = "/es" + (stripped === "/" ? "" : stripped) + (search || "");
  const enPath = stripped + (search || "");

  return { lang, t, enPath, esPath };
}
